import { Separator } from './ui/separator';
import logo from "../assets/logo.png"

interface FooterProps {
  t: any;
  nav: any;
  onPageChange: (page: string) => void;
}

export default function Footer({ t, nav, onPageChange }: FooterProps) {
  const currentYear = new Date().getFullYear();

  const navItems = [
    { key: 'home', label: nav.home },
    { key: 'about', label: nav.about },
    { key: 'product', label: nav.product },
    { key: 'case-studies', label: nav.caseStudies },
  ];

  const legalLinks = [
    { key: 'warranty', label: t.links.warranty },
    { key: 'purchase', label: t.links.purchase },
    { key: 'privacy', label: t.links.privacy },
  ];

  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <img src={logo} className='w-30 -mt-5 -mb-5' alt="" />
            <p className="text-gray-300 leading-relaxed">
              {t.description}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">{t.navigation}</h4>
            <ul className="space-y-2">
              {navItems.map((item) => (
                <li key={item.key}>
                  <button
                    onClick={() => onPageChange(item.key)}
                    className="text-gray-300 cursor-pointer hover:text-emerald-600 transition-colors"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">{t.legalInformation}</h4>
            <ul className="space-y-2">
              {legalLinks.map((link) => (
                <li key={link.key}>
                  <button
                    onClick={() => onPageChange(link.key)}
                    className="text-gray-300 cursor-pointer hover:text-emerald-600 transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Separator className="my-8 bg-gray-800" />

        <div className="text-center">
          <p className="text-gray-400">
            © {currentYear} {t.company}. {t.allRightsReserved}.
          </p>
        </div>
      </div>
    </footer>
  );
}